import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const ToastContainerWithControls = lazy(() => import('./ToastContainerWithControls'))

;(async () => {
	const { scheduleToast } = await import('.')
	window.scheduleToast = scheduleToast
})()

;(async () => {
	const { default: SetupToastEvents } = await import('./toastEvents')
	SetupToastEvents()
})()

class ToastContainerWebComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<ToastContainerWithControls />
			</RootProviders>
		)
	}
}

customElements.define('toast-container', ToastContainerWebComponent)
